import { render } from "./EditChannels.vue?vue&type=template&id=89784cee"
import script from "./EditChannels.vue?vue&type=script&lang=js"
export * from "./EditChannels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__